'use strict';

/**
 * Égalise la hauteur des .highlight-- d'un même bloc multi-colonnes
 * (.f-wysiwyg__column) sur la hauteur du plus grand, pour que les <hr>
 * (underlines) qui suivent soient alignés entre colonnes.
 * Desktop uniquement : sur mobile les colonnes sont empilées.
 */
const EqualizeHighlight = {
    init: function () {
        const groups = document.querySelectorAll('.f-wysiwyg__column');
        if (!groups.length) return;

        const mq = window.matchMedia('(min-width: 768px)');

        const run = () => {
            groups.forEach(group => {
                const items = group.querySelectorAll('.highlight--');
                if (items.length < 2) return;

                // reset avant mesure
                items.forEach(el => { el.style.minHeight = ''; });
                if (!mq.matches) return;

                let max = 0;
                items.forEach(el => { max = Math.max(max, el.offsetHeight); });
                items.forEach(el => { el.style.minHeight = max + 'px'; });
            });
        };

        run();

        // recalcul au resize (debounce)
        let t;
        window.addEventListener('resize', () => {
            clearTimeout(t);
            t = setTimeout(run, 150);
        });

        // recalcul une fois les webfonts chargées (la hauteur change)
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(run);
        }
    },
};

export default EqualizeHighlight;
